// Gallery Image Switcher
function changeImage(src, thumb) {
    document.getElementById('mainImage').src = src;
    document.querySelectorAll('.thumb').forEach(t => t.classList.remove('active'));
    thumb.classList.add('active');
}

// Supply Selector
function selectSupply(element) {
    document.querySelectorAll('.supply-option').forEach(opt => {
        opt.classList.remove('selected');
    });
    element.classList.add('selected');
    
    const price = element.getAttribute('data-price');
    document.getElementById('addToCart').textContent = `ADD TO CART — $${price}`;
}

// Sticky CTA visibility
function handleStickyVisibility() {
    const hero = document.querySelector('.hero');
    const sticky = document.querySelector('.sticky-cta');
    
    if (window.innerWidth <= 768) {
        const heroRect = hero.getBoundingClientRect();
        if (heroRect.bottom < 0) {
            sticky.style.display = 'block';
        } else {
            sticky.style.display = 'none';
        }
    }
}

window.addEventListener('scroll', handleStickyVisibility);
window.addEventListener('resize', handleStickyVisibility);

// Smooth scroll for anchor links
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
        e.preventDefault();
        const target = document.querySelector(this.getAttribute('href'));
        if (target) {
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    });
});

// Add to Cart button animation
document.querySelectorAll('.btn-cta, .btn-cta-small').forEach(btn => {
    btn.addEventListener('click', function() {
        const originalText = this.textContent;
        this.textContent = '✓ Added to Cart!';
        this.style.background = '#1b4332';
        
        setTimeout(() => {
            this.textContent = originalText;
            this.style.background = '';
        }, 2000);
    });
});

// Intersection Observer for fade-in animations
const observerOptions = {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
};

const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            entry.target.style.opacity = '1';
            entry.target.style.transform = 'translateY(0)';
        }
    });
}, observerOptions);

// Apply fade-in to sections
document.addEventListener('DOMContentLoaded', () => {
    const sections = document.querySelectorAll('section');
    sections.forEach(section => {
        section.style.opacity = '0';
        section.style.transform = 'translateY(20px)';
        section.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
        observer.observe(section);
    });
    
    // Make hero visible immediately
    const hero = document.querySelector('.hero');
    if (hero) {
        hero.style.opacity = '1';
        hero.style.transform = 'translateY(0)';
    }
});
